import { defineMessages } from 'react-intl';
const i18nKey = 'GlobalPreferences';
const messages = defineMessages({
  closeA11yLabel: {
    id: `${i18nKey}.closeA11yLabel`,
    defaultMessage: 'Close',
    description: `
      #Component:button
      #CharLimit:none
      #Context:Aria label for close button
    `
  },
  backA11yLabel: {
    id: `${i18nKey}.backA11yLabel`,
    defaultMessage: 'Back',
    description: `
      #Component:button
      #CharLimit:none
      #Context:Aria label for back button
    `
  },
  globalPreferenceTitle: {
    id: `${i18nKey}.globalPreferenceTitle`,
    defaultMessage: 'Global preferences',
    description: `
      #Component:Header
      #CharLimit:100
      #Context:Title for the modals and drawers where the global preferences are displayed
    `
  },
  countryLabel: {
    id: `${i18nKey}.countryLabel`,
    defaultMessage: 'Country / region',
    description: `
      #Component:ListCell
      #CharLimit:50
      #Context:Label for a tab that displays the current country
    `
  },
  languageLabel: {
    id: `${i18nKey}.languageLabel`,
    defaultMessage: 'Language',
    description: `
      #Component:ListCell
      #CharLimit:50
      #Context:Label for a tab that displays the current language
    `
  },
  searchPlaceholder: {
    id: `${i18nKey}.searchPlaceholder`,
    defaultMessage: 'Search',
    description: `
      #Component:Input
      #CharLimit:50
      #Context:Placeholder text for country search input
    `
  },
  globalLabel: {
    id: `${i18nKey}.globalLabel`,
    defaultMessage: 'Global',
    description: `
      #Component:ListCell
      #CharLimit:50
      #Context:Label to describe that the user has selected the global version of the website. That is, the website if not for any specific country
    `
  }
});
export { messages as default };
//# sourceMappingURL=messages.js.map
